import { request } from '@/shared/api/request'

export const sendPhone = (params) => {
	return request({ url: '/user/sendSms', method: 'POST', params })
}
